// extracted by mini-css-extract-plugin
module.exports = {"AuthLayout":"AuthLayout_AuthLayout__JR37b","Left":"AuthLayout_Left__3F1RQ","Right":"AuthLayout_Right__1tYgv","ChildrenContainer":"AuthLayout_ChildrenContainer___wEA0"};